import { transformUnits } from '@/helpers/unit-formatter/unit-formatter';
import { FormattedUnitLabels, UnitValue } from '@/helpers/unit-formatter/unit-formatter.types';
import {
  degreesToWindDirection,
  normalizeDegrees,
  toNumber,
  unitValueToFormattedUnitLabels,
} from '@/helpers/unit-formatter/unit-formatter.utils';

/**
 * Formatter for wind direction display values.
 * Rounds to the nearest degree and appends an 8-point compass label (clockwise from North).
 */
export const formatDirection = (
  unitValue: UnitValue,
  displayUnits?: string
): FormattedUnitLabels => {
  const transformed = transformUnits(unitValue, displayUnits);
  const value = toNumber(transformed.value);

  if (value == null) {
    return unitValueToFormattedUnitLabels({ value: transformed.value, units: undefined });
  }

  const normalized = normalizeDegrees(value);
  const cardinal = degreesToWindDirection(value);
  const unitsLabel = `° ${cardinal}`;

  return {
    valueLabel: `${normalized}`,
    unitsLabel,
    valueUnitsLabel: `${normalized}${unitsLabel}`,
  };
};
